import { extend } from 'flarum/extend';
import app from 'flarum/app';
import IndexPage from 'flarum/forum/components/IndexPage';

app.initializers.add('zr/custom-header', () => {
    const createSocialIcon = (icon, className, link) => {
        if (!link) return;
        return m('a', {
            className: 'nav-item',
            href: link,
            title: app.translator.trans(`custom-header.forum.${icon}`),
            target: '_blank',
            rel: 'noopener noreferrer'
        }, m('i', { className }));
    };

    extend(IndexPage.prototype, 'oncreate', function () {
        const headerImage = document.getElementById('StreamsHero-image');
        const bigImageUrl = app.forum.attribute('zr-custom-header.headerBackgroundImage') || `${app.forum.attribute('baseUrl')}/assets/extensions/zr-custom-header/bg.jpg`;
        const smaleImageUrl = app.forum.attribute('zr-custom-header.headerBackgroundImageSmale') || `${app.forum.attribute('baseUrl')}/assets/extensions/zr-custom-header/bg.jpg`;

        const isSmallScreen = window.innerWidth <= 786;
        const imageUrl = isSmallScreen ? smaleImageUrl : bigImageUrl;

        headerImage.style.backgroundImage = `url('${imageUrl}')`;
        headerImage.style.backgroundSize = 'cover';
    });

    extend(IndexPage.prototype, 'view', function (vdom) {
        if (vdom.children && vdom.children.splice) {
            const insert =
                m('div', { className: 'StreamsHero-image', id: 'StreamsHero-image' }, [
                    m('div', { className: 'js-nav', 'data-element': 'logo', target: '_blank' }, [
                        createSocialIcon('twitter', 'socialic fab fa-twitter', app.forum.attribute('twitterIcon')),
                        createSocialIcon('facebook', 'socialic fab fa-facebook-square', app.forum.attribute('facebookIcon')),
                        createSocialIcon('youtube', 'socialic fab fa-youtube', app.forum.attribute('youtubeIcon')),
                        createSocialIcon('discord', 'socialic fab fa-discord', app.forum.attribute('discordIcon')),
                        createSocialIcon('telegram', 'socialic fab fa-telegram', app.forum.attribute('telegramIcon')),
                    ]),
                ]);

            vdom.children.splice(0, 0, insert);
        }
    });
});
